const LinearProgress = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: theme.shape.borderRadius * 5,
      backgroundColor: theme.palette.common.white,
    }),
    bar: ({ theme }) => ({
      borderRadius: theme.shape.borderRadius * 5,
    }),
  },
};

export default LinearProgress;
